import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {MatSnackBarConfig, MatSnackBarRef} from '@angular/material/snack-bar';
import {InformationStatus} from '@ideals/types';

const STATUS_ICON_CLASSES: Record<InformationStatus, string> = {
  [InformationStatus.Success]: 'icons-tick',
  [InformationStatus.Warning]: 'icons-warning',
  [InformationStatus.Danger]: 'icons-cross',
  [InformationStatus.Information]: 'icons-info',
};

@Component({
  selector: 'ideals-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SnackBarComponent {
  constructor(
    private readonly _snackBarRef: MatSnackBarRef<SnackBarComponent>,
  ) {
  }

  public get config(): MatSnackBarConfig {
    return this._snackBarRef.containerInstance.snackBarConfig;
  }

  public get statusIcon(): string {
    return STATUS_ICON_CLASSES[this.config.data.status];
  }

  public close(): void {
    this._snackBarRef.dismiss();
  }
}
